import { useCallback, useRef } from "react"

import { ContentType } from "../../components/Sliders/Slider"
import { useMixpanel } from "../../hooks/use-mixpanel"
import { appStore } from "../../store/AppStore"
import { DomainName } from "../../utilities/constants"

const slugMapper: Partial<Record<ContentType, string>> = {
  // video
  VodConcert: "video",
  //Video: "video", //covered by direct conversion
  LiveConcert: "video",

  // audio
  Album: "audio",
}
export const convertTypeToWebSlug = (type: ContentType) =>
  Object.keys(slugMapper).includes(type) ? slugMapper[type] : type.toLowerCase()

export const usePageviewTracking = (doTrackOnce = true) => {
  const track = useMixpanel()
  const trackOnce = useRef(true)
  const lastRouteIsBackNav = appStore((state) => state.lastRouteIsBackNav)

  return useCallback(
    async (page_type: string | undefined, location: string) => {
      /*don't do anything if the tracker is configured as a page tracker and already submitted
      once before. Also check if the page is loaded from back navigation
       */
      if (
        (doTrackOnce && !trackOnce.current) ||
        lastRouteIsBackNav ||
        !page_type
      )
        return
      trackOnce.current = false
      track("pageview", {
        page_type,
        content_link: DomainName + location,
      })
    },
    [track, lastRouteIsBackNav],
  )
}
